import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import immutable from 'immutable'

import {LunaLoader} from '../widgets/lunaloader/lunaloader.component'

import {LunaMapBox} from '../widgets/lunamapbox.component'
import {ImageGrid} from '../widgets/imagegrid.component'
import {ItemTitleBlock} from '../widgets/layout/itemtitleblock.component'
import {ItemOverviewBlock} from '../widgets/layout/itemoverviewblock.component'
import {ItemReservationBlock} from '../widgets/layout/itemreservationblock.component'
import {RelatedContentBand} from '../widgets/relatedcontentband/relatedcontentband.component'

const ATTRACTION_URL = '/api/v1/attractions/'

export class ActivityItem extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            index: 0,
            isOpen: false,
            activity: null,
            loading: true,
            activeActivity: this.props.activeActivity ? this.props.activeActivity : null,
            activeActivityId: this.props.activeActivityId ? this.props.activeActivityId : null,
            destId: this.props.leg ? this.props.leg.getIn(['destination', 'id']) : null
        }

        _.bindAll(this,
            'addToItin',
            'removeFromItin',
            'goBack',
            'addRelatedToItin',
            'removeRelatedFromItin'
        )
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.loading !== nextState.loading || this.state.activeActivity !== nextProps.activeActivity || this.props.leg.get('id') !== nextProps.leg.get('id')) {
            return true
        } else {
            return false
        }
    }

    componentDidMount() {
        if (this.state.loading) {
            if (this.props.activeActivity && this.props.activeActivity.get('place_id') && !_.includes(this.props.activeActivity.get('place_id'), '-lunamoons')) {
                this.getActivity(this.props.activeActivity.get('place_id'))
            } else if (this.props.activeActivityId) {
                this.getActivity(this.props.activeActivityId)
            } else if (_.includes(this.props.activeActivity.get('place_id'), '-lunamoons')) {
                // This is a user added activity, just set it
                this.setState({loading: false, activity: this.props.activeActivity})
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activeActivity !== this.props.activeActivity) {
            this.setState({
                loading: true,
                activity: null,
                activeActivity: nextProps.activeActivity
            })
            document.body.scrollTop = document.documentElement.scrollTop = 0
            if (nextProps.activeActivity) {
                this.getActivity(nextProps.activeActivity.get('place_id'))
            } else if (nextProps.activeActivityId) {
                this.getActivity(nextProps.activeActivityId)
            }
        }
    }

    getActivity(id) {
        if ((this.state.activeActivityId && !_.includes(this.state.activeActivityId, '-lunamoons')) || (this.state.activeActivity && !_.includes(this.state.activeActivity.get('place_id'), '-lunamoons'))) {
            let self = this
            axios.get(ATTRACTION_URL + id).then(function (response) {
                if (response.data) {
                    self.setState({loading: false, activity: immutable.fromJS(response.data)})
                } else {
                    console.error('ERROR: in getActivity function')
                    console.error(response)
                }
            }).catch(function (error) {
                if (error.response.status == 404) {
                    axios.get(`/api/v1/attractions/places-details/${id}/`).then(function (response) {
                        let data = response.data
                        let attraction = {
                            place_id: data.place_id,
                            id: -1,
                            keywords: data.types,
                            name: data.name,
                            location: {
                                lat: data.geometry.location.lat,
                                lon: data.geometry.location.lng
                            },
                            images: data.photos,
                            details: data
                        }
                        self.setState({loading: false, activity: immutable.fromJS(attraction)})
                    })
                }
            })
        } else {
            if (this.state.activeActivity) {
                this.setState({loading: false, activity: this.state.activeActivity})
            }
        }
    }


    goBack() {
        if (this.props.goBack) {
            this.props.goBack()
        } else {
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.SEARCH)
        }
    }


    addToItin() {
        if (this.props.leg.getIn(['destination', 'id']) === -1 && this.props.addToItinFromOverview) {
            this.props.addToItinFromOverview(this.state.activity)
        } else {
            this.props.onSelectActivity(this.props.leg, this.state.activity, this.props.user)
            // this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.OVERVIEW)
        }
    }


    removeFromItin() {
        this.props.onRemoveActivity(this.props.leg, this.state.activity, this.props.user)
    }


    addRelatedToItin(act) {
        if (this.props.leg.getIn(['destination', 'id']) === -1 && this.props.addToItinFromOverview) {
            this.props.addToItinFromOverview(act)
        } else {
            this.props.onSelectActivity(this.props.leg, act, this.props.user)
        }
    }

    removeRelatedFromItin(act) {
        this.props.onRemoveActivity(this.props.leg, act, this.props.user)
    }

    render() {
        if (this.state.loading) {
            return <LunaLoader style="basic"/>
        } else {
            // let item = immutable.fromJS(this.state.activity)
            let item = this.state.activity
            let body = ''
            if (item.getIn('description') && item.getIn('description') !== '') {
                body = item.get('description')
            } else if (item.getIn(['wiki_description', 'full_text']) && item.getIn(['wiki_description', 'full_text']) !== '') {
                body = item.getIn(['wiki_description', 'full_text'])
            }

            // let allDetails = new immutable.fromJS(JSON.parse(item.get('details')))
            // console.log(allDetails)

            let hours = ''
            if (item.getIn(['details', 'opening_hours', 'weekday_text'])) {
                let allHours = item.getIn(['details', 'opening_hours', 'weekday_text']).toJS()
                _.each(allHours, function (ah) {
                    hours += ah + '<br />'
                })
            }

            // TODO: Related Activities don't appear to have the google images
            let googleImages = []
            if (item.getIn(['details', 'photos'])) {
                let allPhotos = item.getIn(['details', 'photos']).toJS()
                _.each(allPhotos, function (ap, key) {
                    let tempPhoto = {
                        filename: 'https://maps.googleapis.com/maps/api/place/photo?maxwidth=800&photoreference=' + ap.photo_reference + '&key=AIzaSyCvwt0NnxLgeRxHrpdd1eRRVmvXcMVylJI',
                        description: '',
                        copyright: ap.html_attributions,
                        pivot: {
                            in_slideshow: true,
                            slideshow_index: key
                        }
                    }
                    googleImages.push(tempPhoto)
                })
            }

            googleImages = new immutable.fromJS(googleImages)

            let contact = ''
            if (item.getIn(['details', 'formatted_address'])) {
                contact += '<label>Address</label><p>' + item.getIn(['details', 'formatted_address']) + '</p>'
            }
            if (item.getIn(['details', 'international_phone_number'])) {
                contact += '<label>Phone Number</label><p>' + item.getIn(['details', 'international_phone_number']) + '</p>'
            }
            if (item.getIn(['details', 'website'])) {
                contact += '<label>Website</label><p><a href=\'' + item.getIn(['details', 'website']) + '\' target=\'_blank\'>' + item.getIn(['details', 'website']) + '</a></p>'
            }

            // if this is a user added activity, we can't do related yet
            let related =
                <RelatedContentBand {...this.props} item={item} destId={this.state.destId} type="similar" model="attraction" addToItin={this.addRelatedToItin} removeFromItin={this.removeRelatedFromItin}/>
            if (_.includes(item.get('place_id'), '-lunamoons')) {
                related = null
            }

            return (
                <div className="view-area">
                    <div className="view-left-col">
                        <a onClick={() => this.goBack()} className="btn">Go Back</a>
                    </div>
                    <div className="view-center">
                        <ItemTitleBlock item={item} type="attraction" leg={this.props.leg} addToItin={this.addToItin} removeFromItin={this.removeFromItin}/>
                        <ImageGrid images={googleImages} title={item.get('name')}/>
                        <ItemOverviewBlock label='Overview' body={body}/>
                        <ItemOverviewBlock label='Hours' body={hours}/>
                        <ItemOverviewBlock label='Details' body={contact}/>
                        <ItemReservationBlock label='Reservation Details' item={item}/>
                        <LunaMapBox item={item}/>
                        {related}
                    </div>
                    <div className="view-right-col"/>
                </div>
            )
        }
    }
}

// <RelatedContentBand {...this.props} item={item} destId={this.props.leg.getIn(['destination','id'])} type="nearby" model="destination" />
// <RelatedContentBand {...this.props} item={item} destId={this.props.leg.getIn(['destination','id'])} type="nearby" model="accommodation" />
